import React from 'react';
import { FormattedMessage } from 'react-intl';

let { id: module_id } = module;

/**
 * Shows green text indicating that person is closest contact (lähiyhteyshenkilö)
 *
 * @returns {*}
 * @constructor
 */
const ClosestContactInfo = () => {
  return (
    <div>
      <div className="row-fluid span12 closestContact">
        <FormattedMessage id={`${module_id}.closestContact`} />
        <i className="icon-info ot-cl-tooltip">
          <span className="tooltiptext">
            <FormattedMessage id={`${module_id}.closestContactInfo`} />
          </span>
        </i>
      </div>
    </div>
  );
};

export default ClosestContactInfo;
